module.exports = __webpack_public_path__ + "fonts/img-icon.svg";